import { deepOrange, deepPurple, common, green } from "@mui/material/colors";

export function getBackgroundColor(num) {
  if (num >= 19) {
    return green[500];
  } else if (num >= 13) {
    return deepPurple[500];
  } else if (num >= 6) {
    return deepOrange[500];
  } else {
    return common[500];
  }
}
